var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThermostat = function SvgThermostat(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8091",
    width: 32,
    height: 32,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer5",
    fill: "currentColor",
    transform: "translate(0 -14)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "path8716",
    cx: 8.743,
    cy: 27.182,
    r: 1.856
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect8730",
    d: "M6.423 16.508v7.89h.928v-7.89zm3.712 0v7.89h.928v-7.89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rect8734",
    d: "M8.279 19.757h.928v6.497h-.928z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4153",
    d: "M7.35 23.745a3.72 3.72 0 0 0-2.32 3.437c0 2.045 1.668 3.713 3.713 3.713s3.713-1.668 3.713-3.713a3.72 3.72 0 0 0-2.32-3.437v1.037a2.778 2.778 0 0 1-1.392 5.185 2.778 2.778 0 0 1-1.393-5.185z",
    color: "currentColor",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4155",
    d: "M8.743 14.188a2.33 2.33 0 0 0-2.32 2.32h.928c0-.774.618-1.392 1.392-1.392.775 0 1.392.618 1.392 1.393h.929a2.33 2.33 0 0 0-2.32-2.321",
    color: "currentColor",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textTransform: "none",
      whiteSpace: "normal"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThermostat);
export default ForwardRef;